export default __webpack_public_path__ + "static/media/c++.b16266e0.png";